import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/pro-regular-svg-icons';
import { useTranslation } from 'react-i18next';
import { Button } from '@e2n/ui';
import dayjs from '@/domain/mitarbeiter/shared/utils/dayjs';
import { useRotationsplanFeatureContext } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/RotationsplanFeatureContext';
import { RefObject } from 'react';

export function YearNavigationHeader({
  kalenderWocheRef,
}: {
  kalenderWocheRef: RefObject<HTMLDivElement>;
}) {
  const { t } = useTranslation();
  const {
    store: {
      ui: { year },
      setYear,
    },
  } = useRotationsplanFeatureContext();

  const handleTodayClick = () => {
    const currentYear = dayjs(new Date()).get('year').toString();

    if (kalenderWocheRef?.current) {
      kalenderWocheRef.current.scrollIntoView({
        inline: 'center',
        block: 'nearest',
      });
    }

    setYear(currentYear);
  };

  const handlePrevYearClick = () => {
    const newYear = dayjs(year).subtract(1, 'year').get('year').toString();
    setYear(newYear);
  };

  const handleNextYearClick = () => {
    const newYear = dayjs(year).add(1, 'year').get('year').toString();
    setYear(newYear);
  };

  return (
    <div className="flex items-center gap-4">
      <Button onClick={handleTodayClick} variant="outline-secondary">
        {t('general.date.today')}
      </Button>
      <div className="flex items-center">
        <Button size="icon" variant="icon" onClick={handlePrevYearClick}>
          <FontAwesomeIcon
            className="text-neutrals-700 text-xl"
            icon={faChevronLeft}
          />
        </Button>
        <Button size="icon" variant="icon" onClick={handleNextYearClick}>
          <FontAwesomeIcon
            className="text-neutrals-700 text-xl"
            icon={faChevronRight}
          />
        </Button>
      </div>
      <div className="text-xl font-semibold">{year}</div>
    </div>
  );
}
